import { render } from "./InputArea.vue?vue&type=template&id=5fda596a"
import script from "./InputArea.vue?vue&type=script&lang=js"
export * from "./InputArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__